import { useState } from 'react';
import { Text } from '@radix-ui/themes';

type ShortableTextProps = {
  text: string;
  textLength?: number;
};

const ShortableText = ({ text, textLength = 50 }: ShortableTextProps) => {
  const [isShort, setIsShort] = useState<boolean>(text && text.length > textLength ? true : false);

  const [isShortable] = useState<boolean>(text && text.length > textLength ? true : false);

  if (isShortable) {
    return (
      <Text
        className="cursor-pointer"
        onClick={() => {
          setIsShort(!isShort);
        }}
        dangerouslySetInnerHTML={{
          __html: isShort ? `${text.substring(0, textLength)}...` : text,
        }}
      />
    );
  }

  return <Text dangerouslySetInnerHTML={{ __html: text }} />;
};

export default ShortableText;
